import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-screen-container',
  imports: [RouterOutlet],
  templateUrl: './screen-container.html',
  styleUrl: './screen-container.css'
})
export class ScreenContainer {

}
